module.exports = __webpack_public_path__ + "static/media/7_shape_r.0e08f646.webp";